/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxLength: NonNullable<unknown> }} Passwordtoolongerror3Inputs */

const en_passwordtoolongerror3 = /** @type {(inputs: Passwordtoolongerror3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Password must be at most ${i?.maxLength} characters`)
};

const de_passwordtoolongerror3 = /** @type {(inputs: Passwordtoolongerror3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Passwort darf höchstens ${i?.maxLength} Zeichen lang sein`)
};

/**
* | output |
* | --- |
* | "Password must be at most {maxLength} characters" |
*
* @param {Passwordtoolongerror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordtoolongerror3 = /** @type {((inputs: Passwordtoolongerror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordtoolongerror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordtoolongerror3(inputs)
	return de_passwordtoolongerror3(inputs)
});
export { passwordtoolongerror3 as "passwordTooLongError" }